import { RequestService } from "../../../../../common/services/RequestService";
import { UPDATE_OFFER } from "../constants";
import { adjustOfferData, dataUpdateOfferRequest } from "./adjustOfferData";

export const updateOfferRequest = async (profileId, data, ymaps) => {
  const adjustedData = await dataUpdateOfferRequest(data, ymaps);
  const response = await RequestService.put(
    UPDATE_OFFER.replace("{profile_id}", profileId).replace(
      "{offer_id}",
      data.offerId
    ),
    adjustedData
  );
  return response && response.data && adjustOfferData(response.data);
};
